<template>
  <div>
    <v-data-table :headers="headers" :items="employees" hide-actions class="c-insurance-plan simple-table">
      <template slot="items" slot-scope="props">
        <tr>
            <td>{{ props.item.insuredName}}</td>
            <td v-if="props.item.relationWithMain === '01'">本人</td>
            <td v-else-if="props.item.relationWithMain === '10'">配偶</td>
            <td v-else-if="props.item.relationWithMain === '40'">子女</td>
            <td>{{ props.item.identifyNumber }}</td>
            <td>{{ props.item.plan &&  props.item.plan.name}}</td>
            <td>{{props.item.insuredPremium}}</td>
        </tr>
      </template>
    </v-data-table>
    <p style="color:#DD122A;">备注：门急诊医疗、住院医疗在疾病医疗时有30天等待期，重大疾病等待期为90天；</p>
  </div>
</template>

<script>
import dateUtil from "@/assets/js/utils/date";
export default {
  props: {
    employees: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      // 产品方案只有一个方案D了。原来是选择的，从 props 接受，现在只有一个了直接定义在这里
      planId:4,
      headers: [
        {
          text: "员工姓名",
          value: "name",
          sortable: false
        },
        {
          text: "与本人关系",
          value: "insuranceAmountList",
          sortable: false,
          width: "200"
        },
        {
          text: "身份证",
          sortable: false,
          width: "200"
        },
        {
          text: "产品方案",
          sortable: false,
          width: "200"
        },
        {
          text: "保费",
          sortable: false,
          width: "200"
        }
      ],
      rules: {
        plan:[v=> !!v || "请选择方案"]
      },
      amount:0,
      planList:[]
    };
  },
  computed: {
    itLists(){
      return this.$store.state.insure.tk_it;
    }
  },
  created () {
    this.getPlan();
    this.getPlanList();
  },
  methods: {
    getPlan(){
      let arr = [];
      this.employees.filter(item => {
        if (item.plan) {
          arr.push({
            planId:item.plan.planId,
            planPremium:'',
            planName:'',
            ipIds:item.plan.ipIds,
            quotaPlanCode:item.plan.quotaPlanCodes[this.getAgeByNum(item.identifyNumber)],
            insuredList:[],
            kindList:[]
          });
        }
      });
      this.planList = this.filterArr(arr,'quotaPlanCode');
    },
    //整理json
    getPlanList(){
      let allPrice = 0;
      this.planList.forEach((value,index) => {
        let insuredList = [];
        let planPrice = 0;
        this.employees.find(item => {
          item.insuredPremium = this.getPrice(item.plan.ipIds , item.identifyNumber);
          if (value.quotaPlanCode === item.plan.quotaPlanCodes[this.getAgeByNum(item.identifyNumber)]) {
             insuredList.push({
               insuredPremium:this.getPrice(item.plan.ipIds , item.identifyNumber),
               insuredName:item.insuredName,
               sex:dateUtil.getIdBySex(item.identifyNumber),
               occupation:item.occupation.code,
               hasSocialInsurance:item.hasSocialInsurance ? 0 : 1,
               identifyNumber:item.identifyNumber,
               identifyType:item.identifyType,
               birthday:dateUtil.getBirthdayByID(item.identifyNumber),
               mobilephone:item.mobilephone,
               healthStatus:item.healthStatus?0:1,
               relationWithMain:item.relationWithMain,
               mainIdentifyNumber:item.mainIdentifyNumber
             });
             planPrice+=this.getPrice(item.plan.ipIds , item.identifyNumber);
          }
        });
        value.planName='计划'+(index+1);
        value.planPremium = planPrice;
        value.insuredList = insuredList; 
        value.kindList = this.getkindList(value.ipIds);
        allPrice+=value.planPremium;
      });
      this.amount = allPrice;
      this.$emit("price",this.amount)
    },
    // 根据对象中的属性进行去重
    filterArr(arr, name) {
      let hash = {};
      return arr.reduce((ss, item) => {// reduce累计器, ss是具体满足条件后返回的数据, item是数组依次循环的每一项
          hash[item[name]] ? '' : hash[item[name]] = true && ss.push(item);
          // 1、判断对象的键值是否存在
          return ss;
      }, []);
    },
    // 获取保费公共方法
    getPrice(ipIds,identifyNumber){
      var price = 0;
      this.itLists.map(item => {
        ipIds.map(value => {
          if (item.ipId === value) {
            price += item.premium[this.getAgeByNum(identifyNumber)]
          }
        })
      }); 
      return price;
    },
    //根据身份证来判断年龄所对应的位置
    getAgeByNum(idCard){
      const birthday = dateUtil.getBirthdayByID(idCard)
      const age = dateUtil.getAge(birthday);
      if (age >= 0 && age <= 39) {
        return 0;
      } else if (age >= 40 && age <= 50){
        return 1;
      } else if (age >= 51 && age <=60 ) {
        return 2;
      }
    },
    //险别集合
    getkindList(ipIds){
      const arr = [];
      this.itLists.map(item => {
        ipIds.map(value => {
          if (item.ipId === value) {
            arr.push(item);
          }
        })
      });
      return this.getkindArr(arr);
    },
    getkindArr(arr) {
      let all = [];
      arr.forEach((value) => {
        let arrItem=[];
        value.amounts.forEach((item,index)=>{
          if (value.kindExtendParams[index] === '') {
            arrItem.push({
              amount:item,
              clausesCode:value.clausesCode[index],
              kindCode:value.kindCodes[index],
            });
          } else {
            arrItem.push({
              amount:item,
              clausesCode:value.clausesCode[index],
              kindCode:value.kindCodes[index],
              kindExtendParams:'{'+value.kindExtendParams[index]+'}'
            });
          }
        });
        all.push(arrItem);
      });
      return all.flat();
    }
  },
  watch: {
    employees:{
      handler:function () {
        this.getPlan();
        this.getPlanList();
        this.$emit("update", this.planList);
      },
      deep:true
    }
  }
};
</script>

<style lang="scss">
.c-insurance-plan {
  width: 745px;
  .thead-th {
    width: 195px;
    .thead-input {
      width: 3em;
      display: inline-block;
    }
  }
  // 框架样式覆盖
  .v-text-field.v-text-field--solo .v-input__control {
    flex: none;
    width: 120px;
    min-height: 30px;
  }
  .v-select {
    justify-content: center;
    font-size: inherit;
  }
}
</style>